<template>
  <div>
    <mdb-btn @click="handleOk" color="primary" size="lg">{{
      $t("giftcard_import")
    }}</mdb-btn>
    <mdb-btn @click="handleOk" color="primary" size="lg">{{
      $t("giftcard_add_new")
    }}</mdb-btn>
    <DataTable
      :columns="columns"
      :getcontentpath="getgiftcardspath"
      :archivecontentpath="archivegiftcardpath"
      :jsonobject="'giftcards'"
      :archiveparam="'giftcardid'"
      :button1="'Muokkaa'"
      :button2="'Arkistoi'"
      v-on:button1="editGiftcard"
    />
  </div>
</template>

<script>
import { mdbBtn } from "mdbvue";
import DataTable from "@/components/DataTable.vue";
export default {
  name: "Giftcards",
  components: {
    DataTable,
    mdbBtn
  },
  methods: {
    editGiftcard(rowData) {
      this.$router.push("/addgiftcard/" + rowData.id);
    }
  },
  data: () => ({
    getgiftcardspath: "/2.0/newbe/giftcards?sessionid=",
    archivegiftcardpath: "/2.0/newbe/giftcards/",
    columns: [
      {
        name: "id",
        visible: false
      },
      {
        name: "title",
        title: "Otsikko",
        width: "150px",
        titleClass: "black-text",
        dataClass: "black-text font-weight-bold h5"
      },
      {
        name: "description",
        title: "Kuvaus",
        width: "150px",
        titleClass: "black-text",
        dataClass: "black-text font-weight-bold h5"
      },
      {
        name: "image",
        title: "Kuva",
        width: "150px",
        titleClass: "black-text",
        dataClass: "black-text"
      },
      {
        name: "active",
        title: "Aktiivinen",
        width: "50px",
        titleClass: "black-text",
        dataClass: "black-text"
      },
      {
        name: "validuntil",
        title: "Voimassa",
        width: "100px",
        titleClass: "black-text",
        dataClass: "black-text"
      },
      {
        name: "chainid",
        title: "Ketjun numero",
        width: "50px",
        titleClass: "black-text",
        dataClass: "black-text"
      },
      {
        name: "control-slot",
        title: "Toiminto",
        width: "100px",
        titleClass: "black-text"
      }
    ]
  }),
  mounted() {}
};
</script>
